export default class StructureNodesWebService {
    constructor($sbRequest, API_VERSION) {
        "ngInject";
        this.$sbRequest = $sbRequest;
        this.API_VERSION = API_VERSION;
    }

    /**
     * This endpoint returns a list representation of the project structure.
     *
     * @param projectId {string}    UUID
     */
    getCollection(projectId) {
        const endpointUrl = `/api/${this.API_VERSION}/api/projects/${projectId}/structure-nodes`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "GET",
        });
    }

    /**
     * This endpoint returns QR Codes as PDF representation of the structure nodes in the project.
     *
     * @param projectId {string}    UUID
     *
     * @param query {Object}            Query parameter
     * @param query.language {string}       A language abbreviation string.
     * @param query.layout {string}         A supported zweckform layout.
     */
    printCollection(projectId, { language, layout, as = "qr_codes", i18n }) {
        const endpointUrl = `/api/${this.API_VERSION}/api/projects/${projectId}/structure-nodes`;
        return this.$sbRequest.pdf({
            url: endpointUrl,
            method: "GET",
            query: {
                layout,
                as,
                i18n,
            },
            header: {
                "Accept-Language": language,
            },
        });
    }

    /**
     * This endpoint returns the structure node by id.
     *
     * @param projectId {string}    UUID
     * @param structureId {string}    The unique identifier of the structure you are requesting a resource for.
     */
    get(projectId, structureId) {
        const endpointUrl = `/api/${this.API_VERSION}/api/projects/${projectId}/structure-nodes/${structureId}`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "GET",
        });
    }

    /**
     * This endpoint creates a new structure node in the project.
     *
     * @param projectId {string}    UUID
     *
     * @param body {Object}    Request body
     * @param body.code {string}    User defined code of the structure node (short identifier).
     * @param body.name {string}    User defined name of the structure node.
     * @param [body.parent_id] {string}    The unique identifier of the parent structure node if one exists. If none is provided the new node will be a root node of the project.
     */
    create(projectId, { code, name, parent_id }) {
        const endpointUrl = `/api/${this.API_VERSION}/api/projects/${projectId}/structure-nodes`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "POST",
            body: { code, name, parent_id },
        });
    }

    /**
     * This endpoint allows to update some properties.
     *
     * @param projectId {string}    UUID
     * @param structureId {string}    The unique identifier of the structure you are requesting a resource for.
     *
     * @param body {Object}    Request body
     * @param body.code {string}    User defined code of the structure node (short identifier).
     * @param body.name {string}    User defined name of the structure node.
     */
    update(projectId, structureId, { code, name }) {
        const endpointUrl = `/api/${this.API_VERSION}/api/projects/${projectId}/structure-nodes/${structureId}`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "PUT",
            body: { code, name },
        });
    }

    /**
     * This endpoint allows to remove a structure node AND all it's children.
     *
     * @param projectId {string}    UUID
     * @param structureId {string}    The unique identifier of the structure you are requesting a resource for.
     */
    delete(projectId, structureId) {
        const endpointUrl = `/api/${this.API_VERSION}/api/projects/${projectId}/structure-nodes/${structureId}`;
        return this.$sbRequest.json({
            url: endpointUrl,
            method: "DELETE",
        });
    }
}
